export default __webpack_public_path__ + "static/media/search.e1652ade.svg";